import { DOCUMENT } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { first } from "rxjs/operators";

import { AuthJwtService, AuthService } from "@lantern/app/core/auth";
import { RuntimeConfigService } from "@lantern/app/core/utils";

@Component({
  templateUrl: "./go-login.template.html"
})
export class GoLoginPageComponent implements OnInit {
  location: Location;

  get redirectPath(): string {
    const queryParams = this.activatedRoute.snapshot.queryParams;
    return queryParams.redirect || "/";
  }

  get globalLoginUrl(): Promise<string> {
    return this.runtimeConfig.value.then(({ globalAuthUrl }) => (
      `${globalAuthUrl}/#/login?redirect=${encodeURIComponent(this.location.href)}`
    ));
  }

  constructor(
    private authService: AuthService,
    private authJwt: AuthJwtService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private runtimeConfig: RuntimeConfigService,
    @Inject(DOCUMENT) document: any
  ) {
    this.location = document.defaultView.location;
  }

  ngOnInit(): void {
    this.authService.isLoggedIn.pipe(first()).subscribe((isLoggedIn) => {
      if (isLoggedIn) {
        this.followRedirect();
      } else {
        this.authJwt.martJwtToken.next(undefined);
        this.goToGlobalLogin();
      }
    });
  }

  private followRedirect(): void {
    this.router.navigateByUrl(this.redirectPath);
  }

  private async goToGlobalLogin(): Promise<void> {
    this.location.replace(await this.globalLoginUrl);
  }
}
